import {
  Component,
  EventEmitter,
  Output,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { BciWkModalService, BCI_WK_MODAL_DATA } from '@bci/webkitbci';

@Component({
  selector: 'app-modal-eliminar-data',
  templateUrl: './modal-eliminar-data.component.html',
  styleUrls: ['./modal-eliminar-data.component.scss'],
  standalone: false
})
export class ModalEliminarDataComponent implements OnInit {
  modalData: any[] = [];
  @Input() item: any;
  @Output() aceptConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedItem: any;
  @Input() Fecha: any;

  constructor(
    private modal: BciWkModalService,
    @Inject(BCI_WK_MODAL_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.modal.setStyles({
      containerStyle: {
        maxWidth: '600px',
        width: '100%',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: '16px',
        overflowY: 'hidden',
      },
    });
  }

  close() {
    this.modal.close();
    const modal = document.getElementById('mymodal');
    if (modal) {
      modal.style.display = 'none';
    }
  }

  confirm() {
    this.data.aceptConfirm();
    this.modal.close();
  }
}
